export default "__VITE_ASSET__D04CeC2J__"